import React from 'react';
import styles from './index.module.scss';

import LoaderPanel from '../../components/LoaderPanel/LoaderPanel';

const LoadingPage: React.FC = () => {

  return (
    <div className={styles.loadingContainer}>
      <LoaderPanel active={true} />
    </div>
  );
};

export default LoadingPage; 